import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=03050832&scoped=true"
import script from "./CatalogList.vue?vue&type=script&lang=js"
export * from "./CatalogList.vue?vue&type=script&lang=js"
import style0 from "./CatalogList.vue?vue&type=style&index=0&id=03050832&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03050832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03050832')) {
      api.createRecord('03050832', component.options)
    } else {
      api.reload('03050832', component.options)
    }
    module.hot.accept("./CatalogList.vue?vue&type=template&id=03050832&scoped=true", function () {
      api.rerender('03050832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalogs/CatalogList.vue"
export default component.exports